module.exports = __webpack_public_path__ + "static/media/QBO-offline-auto-import-invoices.a6dd95f7.png";